<script>

import axios from 'axios';

export default class BadgesRepository{
    

    async createBadge(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deleteBadge(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }


}
</script>
